import { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FormDispatchContext } from '../../contexts/FormContext';
import '../../styles/nps-rating.css';
// ----------------------------------------------------------------------

export default function NPSRating(props) {
    
    const [ npsRating, setNPSRating ] = useState('-');
    const settingsUpdate = useContext(FormDispatchContext);

    const handleChange = (value) => { 
        setNPSRating( Number(value) );
        settingsUpdate({ type: 'set_question_answer', questionID: props.question.question_id, providedAnswer: Number(value) });
        console.log('new NPS rating selected as ' + value);
    }

    if ( typeof(props.question) === 'undefined' ) return;

    return ( 
    <Box className="workingfeedback-question-block" data-question-type="NPS_RATING" data-tracked={props.question?.tracked} data-multiple-choice="No" data-flag1={props.question?.flag_1} data-flag2={props.question?.flag_2} data-flag3={props.question?.flag_3}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="body2" className="workingfeedback-question-title" component="h6" mb={0}>{ props.question?.text } <span className="workingfeedback-required-star">*</span></Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={21} className="npx-rating">
                {[...Array(11)].map((_, index) => (
                <button
                    key={index}
                    onClick={() => handleChange(Number(index))}
                    className={`rating-button ${npsRating === index ? "rating-selected" : "rating-unselected"}`}
                >
                    {index}
                </button>
                ))}
                <Typography variant="body2">0 = Not likely at all, 10 = Extremely likely</Typography>
            </Grid>
        </Grid>
    </Box>
    )
}
